/* global $, preloader, Scrollbar: false */

( function() {
	'use strict';
} )();

$( document ).ready(function() {
	let postsSlider = $("*[data-cards-slider-home]");
	if (postsSlider.length > 0) {
		postsSlider.each(function() {
			let slickWrapper = $(this);
			let slickElement = $(this).find(".cards-wrapper");
			let postsSliderSettings = {
				prevArrow: slickWrapper.find(".card-prev"),
				nextArrow: slickWrapper.find(".card-next"),
				mobileFirst: false,
				lazyLoad: false,
				autoplay: false,
				infinite: false,
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows: false,
				dots: false,
				dotsClass: slickWrapper.hasClass("home-any") ? "slick-dots d-block d-lg-none" : "slick-dots d-none",
				responsive: [
					{
						breakpoint: 960,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true
						}
					},
				]
			};

			slickElement.slick(postsSliderSettings);
		});
	}

	//For hero video added this ability to disable on mobile
	function updateContent() {
		var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (windowWidth < 767) {
			$('#hero_video, #desktop-body-video').addClass('d-none');
			$('#wrapper-first-slideshow-mobile').removeClass('d-none');
		} else {
			$('#wrapper-first-slideshow-mobile').addClass('d-none');
			$('#hero_video, #desktop-body-video').removeClass('d-none');
		}
	}
	updateContent();
	window.addEventListener("resize", updateContent);
});
